module.exports = __webpack_public_path__ + "static/img/OOSH_086.86d4e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_086.jpg
// module id = vOyL
// module chunks = 170